import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { cx } from "../../../react-helpers/css";
import { Organization } from "../../../services/organization/organizationModel";
import { PremiumSponsorship } from "../../../services/premiumSponsorship/premiumSponsorshipModel";
import { premiumSponsorshipService } from "../../../services/premiumSponsorship/premiumSponsorshipService";
import { useConfirmationWithIntl } from "../../../components/ConfirmationDialog";
import useReload from "../../../hooks/useReload";

const { revokePremiumSponsorship } = premiumSponsorshipService();

const STATUS_LABEL_KEYS = {
  invited: "organization:premium-sponsorship.status.INVITED",
  accepted: "organization:premium-sponsorship.status.ACCEPTED",
  declined: "organization:premium-sponsorship.status.DECLINED",
  revoked: "organization:premium-sponsorship.status.REVOKED",
} as const;

const PremiumSponsorshipsTable = ({
  organization,
  sponsorships,
}: {
  organization: Organization;
  sponsorships: PremiumSponsorship[];
}) => {
  const { t } = useTranslation(["organization"]);
  const { confirm } = useConfirmationWithIntl(["organization"]);
  const reload = useReload();

  return sponsorships.length > 0 ? (
    <table className="lblock table">
      <thead>
        <tr>
          <th>{t("organization:premium-sponsorship.table-headers.EMAIL")}</th>
          <th>{t("organization:premium-sponsorship.table-headers.STATUS")}</th>
          <th>
            {t("organization:premium-sponsorship.table-headers.SENT_DATE")}
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        {sponsorships.map((sponsorship) => (
          <tr key={`premium-sponsorship-${sponsorship.id}`}>
            <td>{sponsorship.email}</td>
            <td>
              <span
                className={cx([
                  "user-status-chip --block",
                  sponsorship.status === "accepted" && "--active",
                  (sponsorship.status === "declined" ||
                    sponsorship.status === "revoked") &&
                    "--disabled",
                ])}
              >
                {t(STATUS_LABEL_KEYS[sponsorship.status])}
              </span>
            </td>
            <td>{format(new Date(sponsorship.invitedAt), "dd/MM/yyyy")}</td>
            <td>
              {(sponsorship.status === "invited" ||
                sponsorship.status === "accepted") && (
                <button
                  className="btn--icon --simple --revoke"
                  title={t("organization:premium-sponsorship.REVOKE_TIP")}
                  onClick={() => {
                    confirm(
                      "organization:premium-sponsorship.confirm-revoke.MESSAGE",
                      () =>
                        revokePremiumSponsorship(
                          organization.id,
                          sponsorship.id,
                        ).then(() => reload()),
                      true,
                    );
                  }}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div className="info --compact lblock">
      {t("organization:premium-sponsorship.NO_SPONSORSHIPS_FOUND")}
    </div>
  );
};

export default PremiumSponsorshipsTable;
